import React, { useRef } from 'react';
import './SuggestionButtons.css';

const SuggestionButtons = ({ suggestions, onSuggestionClick }) => {
  const scrollRef = useRef(null);

  const scrollToStart = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="suggestions-container">
      <div className="suggestions-scroll" ref={scrollRef}>
        {suggestions.map((suggestion, index) => (
          <button
            key={index}
            className="suggestion-button"
            onClick={() => {
              onSuggestionClick(suggestion);
              // Scroll back to start after clicking
              setTimeout(scrollToStart, 300);
            }}
          >
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuggestionButtons; 